// extracted by mini-css-extract-plugin
module.exports = {"SectionPanel":"SectionPanel--2nVZM"};